import { QueryHookOptions } from '@apollo/client';

import {
  RetailerNetworkScanDataSubmissionsQuery,
  RetailerNetworkScanDataSubmissionsQueryVariables,
  RetailerNetworkScanDataWeeklySubmissionFilter,
  RetailerNetworkScanDataSubmissionsFragment,
  useRetailerNetworkScanDataSubmissionsQuery,
} from '@occc/graphql';
import { PaginationInfo, usePaginatedQuery } from '@occc-app/hooks/usePaginatedQuery';

type UseRetailerNetworkScanDataSubmissionsProps = {
  pageSize?: number;
  baseOptions?: QueryHookOptions<
    RetailerNetworkScanDataSubmissionsQuery,
    RetailerNetworkScanDataSubmissionsQueryVariables
  >;
  paginationInfo?: PaginationInfo;
  filter: RetailerNetworkScanDataWeeklySubmissionFilter;
};

const transformToSubmissionsArray = (
  data: RetailerNetworkScanDataSubmissionsQuery,
): RetailerNetworkScanDataSubmissionsFragment[] => {
  const { edges } = data.retailerNetworkScanDataWeeklySubmissions;
  return edges?.map((item) => item.node) || [];
};

export const useRetailerNetworkScanDataTobaccoSubmissions = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
}: UseRetailerNetworkScanDataSubmissionsProps) => {
  const response = usePaginatedQuery(
    useRetailerNetworkScanDataSubmissionsQuery,
    'retailerNetworkScanDataWeeklySubmissions.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      ...baseOptions,
      variables: {
        ...baseOptions?.variables,
        filter,
      },
    },
    paginationInfo,
  );

  return {
    ...response,
    data: response.data ? transformToSubmissionsArray(response.data) : response.data,
  };
};
